var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"My 쿠폰함","is-history":""}}),_c('AppContent',[_c('CouponState')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }